export const stellazhi = {
    stellazh__sab__1750x820x450: {
        name: "Стеллаж САБ, мм",
        title: "Стеллаж САБ",
        price: 0,
        active: false,
        type: "1750x820x450",
        height: 1750,
        width: 820,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sab__1750x900x550: {
        name: "Стеллаж САБ, мм",
        title: "Стеллаж САБ",
        price: 0,
        active: false,
        type: "1750x900x550",
        height: 1750,
        width: 900,
        depth: 550,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sab__1850x820x450: {
        name: "Стеллаж САБ, мм",
        title: "Стеллаж САБ",
        price: 0,
        active: false,
        type: "1850x820x450",
        height: 1850,
        width: 820,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sab__1850x900x550: {
        name: "Стеллаж САБ, мм",
        title: "Стеллаж САБ",
        price: 0,
        active: false,
        type: "1850x900x550",
        height: 1850,
        width: 900,
        depth: 550,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1000x700x300: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1000x700x300",
        height: 1000,
        width: 700,
        depth: 300,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1000x1000x400: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1000x1000x400",
        height: 1000,
        width: 1000,
        depth: 400,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1500x700x300: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1500x700x300",
        height: 1500,
        width: 700,
        depth: 300,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1500x1000x400: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1500x1000x400",
        height: 1500,
        width: 1000,
        depth: 400,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1800x700x300: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1800x700x300",
        height: 1800,
        width: 700,
        depth: 300,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1800x1000x400: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1800x1000x400",
        height: 1800,
        width: 1000,
        depth: 400,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1850x850x450: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1850x850x450",
        height: 1850,
        width: 850,
        depth: 450,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__1950x1000x500: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "1950x1000x500",
        height: 1950,
        width: 1000,
        depth: 500,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__2000x700x300: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "2000x700x300",
        height: 2000,
        width: 700,
        depth: 300,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sa__2000x1000x400: {
        name: "Стеллаж СА, мм",
        title: "Стеллаж СА",
        price: 0,
        active: false,
        type: "2000x1000x400",
        height: 2000,
        width: 1000,
        depth: 400,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sum__1800x800x600: {
        name: "Стеллаж СУМ, мм",
        title: "Стеллаж СУМ",
        price: 0,
        active: false,
        type: "1800x800x600",
        height: 1800,
        width: 800,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sum__1800x1000x600: {
        name: "Стеллаж СУМ, мм",
        title: "Стеллаж СУМ",
        price: 0,
        active: false,
        type: "1800x1000x600",
        height: 1800,
        width: 1000,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sum__1800x1200x600: {
        name: "Стеллаж СУМ, мм",
        title: "Стеллаж СУМ",
        price: 0,
        active: false,
        type: "1800x1200x600",
        height: 1800,
        width: 1200,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    stellazh__sum__1800x1500x600: {
        name: "Стеллаж СУМ, мм",
        title: "Стеллаж СУМ",
        price: 0,
        active: false,
        type: "1800x1500x600",
        height: 1800,
        width: 1500,
        depth: 600,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
export const polka__stellazhi = {
    polka__stellazhi__sab__820x450: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sab__900x550: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sa__700x300: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sa__850x450: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sa__1000x400: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sa__1000x500: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sum__800x600: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sum__1000x600: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sum__1200x600: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
    polka__stellazhi__sum__1500x600: {
        name: "Дополнительная полка, шт",
        price: 0,
        active: false,
        type: null,
        piece: 0,
        price_esd: 0,
        isMultyPieces: true,
        position: "down",
    },
};
